"use client";

/**
 * @file 客户端提供者组件
 * @description 包含所有需要在客户端运行的Context提供者
 * 使用"use client"指令标记为客户端组件，因为Context API只能在客户端组件中使用
 *
 * 这个组件解决了Next.js App Router中服务器组件不能使用React Context的问题
 * 通过将所有Context提供者集中在一个客户端组件中，可以在服务器组件中使用Context
 */

import { SessionProvider } from "next-auth/react"; // NextAuth会话提供者
import { ThemeProvider } from "@/context/ThemeContext"; // 主题上下文提供者
import { AuthProvider } from "@/context/AuthContext"; // 认证上下文提供者

/**
 * 客户端提供者组件
 * @description 包含所有需要在客户端运行的Context提供者
 * 按照嵌套顺序：SessionProvider > ThemeProvider > AuthProvider
 * @param {object} props - 组件属性
 * @param {React.ReactNode} props.children - 子组件，将被包裹在所有提供者中
 * @returns {JSX.Element} 嵌套的上下文提供者
 */
export default function ClientProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    // NextAuth v5会话提供者 - 提供认证会话状态
    <SessionProvider>
      {/* 主题提供者 - 提供主题切换功能 */}
      <ThemeProvider>
        {/* 认证提供者 - 提供自定义认证功能 */}
        <AuthProvider>{children}</AuthProvider>
      </ThemeProvider>
    </SessionProvider>
  );
}
